import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import AuthenticatedApp from './AuthenticatedApp';
import UnAuthenticatedApp from './UnauthenditcatedApp';

const RoutedApp = () => {
  const token = localStorage.getItem('token');
  const [isLoggedIn, setIsLoggedIn] = useState(!!token);
  const {user} = useSelector(s => s.user);

  useEffect(() => {
    if (user) {
      setIsLoggedIn(true);
    }
  }, [user]);

  if (isLoggedIn) {
    return <AuthenticatedApp />;
  }
  return <UnAuthenticatedApp />;
};

export default RoutedApp;
